import type { ReactNode } from 'react'
import { Text, View } from 'react-native'

interface SuccessInfoItem {
  icon: ReactNode
  label: string
}

interface SuccessInfoRowProps {
  left: SuccessInfoItem
  right: SuccessInfoItem
}

function InfoItem({ icon, label, alignEnd }: SuccessInfoItem & { alignEnd?: boolean }) {
  return (
    <View className={`flex-row items-center gap-3 lg:flex-1 ${alignEnd ? 'lg:justify-end' : ''}`}>
      <View className="h-10 w-10 shrink-0 items-center justify-center rounded-full bg-canvas-primary">
        {icon}
      </View>
      <Text className="shrink text-base font-normal text-primary">
        {label}
      </Text>
    </View>
  )
}

export function SuccessInfoRow({ left, right }: SuccessInfoRowProps) {
  return (
    <View className="gap-3 lg:flex-row lg:items-center lg:gap-0">
      <InfoItem icon={left.icon} label={left.label} alignEnd />
      <View className="hidden lg:mx-6 lg:flex lg:h-5 lg:w-px lg:bg-border" />
      <InfoItem icon={right.icon} label={right.label} />
    </View>
  )
}